import { useTranslation } from "react-i18next";
import theme from "../../theme";
import * as S from "./styled";

interface CardsProps {
    bestOffer?: string;
    flat?: string;
    price?: string;
    value?: string;
    onClick?: () => void;
    isSelected?: boolean;
}

export default function PlanCard({ price, onClick, isSelected, bestOffer, flat, value }: CardsProps) {
    const { t } = useTranslation();

    return (
        <S.Container onClick={onClick}>
            <S.ContainerFaix style={{ backgroundColor: theme.COLORS.PRIMARY, width: '100%' }}>
                <S.Title>{bestOffer}</S.Title>
            </S.ContainerFaix>
            <S.SubContainer>
                <div>
                    <S.Plan>
                        <S.SelectCircle>
                            {isSelected && <S.Circle />}
                        </S.SelectCircle>
                        <S.PlanText> {flat} </S.PlanText>
                    </S.Plan>
                    {/* <S.Price>{t('planCard_amount_value')} {price}</S.Price> */}
                </div>
                <S.PriceTag>
                    <S.Cifrao>{t('planCard_amount_value')}</S.Cifrao>
                    <S.Value>{value}</S.Value>
                    {/* <S.PriceText>{t('planCard_per_days')}</S.PriceText> */}
                    <S.PriceText>Real</S.PriceText>
                </S.PriceTag>

            </S.SubContainer>
        </S.Container>
    );
};